import {Component, Renderer2} from '@angular/core';
import {
  Platform,
  NavController,
  AlertController,
  ModalController,
  PopoverController,
  PickerController
} from 'ionic-angular';
import {DragulaService} from 'ng2-dragula';
import {LoadingPage} from '../loading/loading';
import {HistoryPage} from '../history/history';
import {VerificationPage} from '../verification/verification';
import {PopoverHidePage} from '../popover-hide/popover-hide';
import {PopoverQuantityPage} from '../popover-quantity/popover-quantity';
import {PopoverSymptomPage} from '../popover-symptom/popover-symptom';
import {PopoverQueuePage} from '../popover-queue/popover-queue';
import {ConstantsProvider} from '../../providers/constants/constants';
import {DataProvider} from '../../providers/data/data';
import {ConsultationDataProvider} from '../../providers/consultation-data/consultation-data';
import {CloudDataProvider} from '../../providers/cloud-data/cloud-data';
import {Subscription} from 'rxjs';
import * as $ from 'jquery';
import { deepClone } from '../../utils/common';

@Component({
  selector: 'page-dispensary',
  templateUrl: 'dispensary.html'
})

export class DispensaryPage {
  private showPickArr = [0, 1, 3, 5, 6, 8, 25, 26, 27];
  private scrollHeight = 0;
  private symptomCats = ['主訴：', '經期史：', '病徵：'];
  private dispCats = ['服用方法', '複方', '單味', '水蜜丸劑', '內服中藥', '外用產品', '複針基本穴位', '單針穴位'];
  private activeTab = 0;
  private sympActive = true;
  private lastSearchStr = '';
  private isSearchActive = false;
  private orderedSymptoms = [];
  private orderedRemarks = [];
  private dispGrpsActive = [];
  private dispPillsActive = [];
  private acuGrpsActive = [];
  private dispSinglesResult = [];
  private dispGrpsResult = [];
  private dispGrpsContentResult = [];
  private dispInternalsResult = [];
  private dispExternalsResult = [];
  private dispPillsResult = [];
  private dispPillsContentResult = [];
  private acuSinglesResult = [];
  private acuGrpsResult = [];
  private acuGrpsContentResult = [];
  private modifiedElements: Set<Element> = new Set<Element>();

  private subs: Subscription = new Subscription();
  /** ----- Constructor ----- **/

  secondUnit: any[] = [
    [],
    [".00", ".05", ".10", ".15", ".20", ".25", ".30", ".35", ".40", ".45", ".50", ".55", ".60", ".65", ".70", ".75", ".80", ".85", ".90", ".95"
    ]
  ];
  numColumns: number = 2; // number of columns to display on picker overlay

  constructor(private constants: ConstantsProvider,
              private data: DataProvider,
              private consultationData: ConsultationDataProvider,
              private platform: Platform,
              private navCtrl: NavController,
              private alertCtrl: AlertController,
              private modalCtrl: ModalController,
              private popoverCtrl: PopoverController,
              private dragService: DragulaService,
              private cloudData: CloudDataProvider,
              private pickerController: PickerController,
              private renderer: Renderer2
  ) {
    // tab choices
    this.activeTab = 0;

    /** Symptoms **/
    this.orderedSymptoms = [[], [], []];
    this.orderedRemarks = [[], [], []];

    for (let i = 0; i < this.consultationData.chosenSymptoms.length; i++) {
      let obj = this.data.getSymptomById(this.consultationData.chosenSymptoms[i]);
      if (obj['name_zh'] == '主訴') {
        this.orderedSymptoms[0].push(obj);
        this.orderedRemarks[0].push(this.consultationData.chosenSymptomsRemark[i]);
      } else if (obj['name_zh'] == 'Lmp' || obj['name_zh'] == 'PMS' || obj['name_zh'] == '帶下') {
        this.orderedSymptoms[1].push(obj);
        this.orderedRemarks[1].push(this.consultationData.chosenSymptomsRemark[i]);
      } else {
        this.orderedSymptoms[2].push(obj);
        this.orderedRemarks[2].push(this.consultationData.chosenSymptomsRemark[i]);
      }
    }
    /** End **/

    this.dragComponentInit()
  }

  /** ----- View LifeCycle ----- **/
  ionViewDidEnter() {
    this.lastSearchStr = '';
    this.onSearchClicked()
  }

  ionViewWillEnter() {
    this.data.currentStep = 1;
    let val = this.platform.height();
    this.scrollHeight = val - 70 - 65 - 150 - 40 - 50 - 50 - 100;
    this.searchDispGrp(this.lastSearchStr);
  }

  ngOnDestroy() {
    // ng-dragula 需要在组件销毁时候才跟随销毁，否则重新 init 也无法正常工作
    if (this.dragService.find('dispensary-bag') != null) {
      this.dragService.destroy('dispensary-bag');
    }
    this.subs.unsubscribe();
  }

  // setup ng-dragula component 初始化拖拉组件
  dragComponentInit() {
    // drag and drop setup
    // dragula="dispensary-bag" 下面的每个 element 都是可拖拽对象
    if (this.dragService.find('dispensary-bag') == null) {
      var temp = this.dragService.createGroup('dispensary-bag', {
        // 判断是否可拖拽
        moves: (el, source, handle, sibling) => {
          const sourceId = source.getAttribute('id')
          if (sourceId.indexOf('dispensary-bag') > -1 || sourceId.indexOf('dispensary-usage') > -1) return true
          return false
        },
        // over target触发，判断本次拖拽是否有效
        accepts: (el, target, source, sibling) => {
          const sourceId = source.getAttribute('id')
          const targetId = target.getAttribute('id')
          if (sourceId == 'dispensary-bag' && (targetId == 'dispensary-detection' || targetId.indexOf('disp-board-container') > -1)) return true
          // dispensary-usage can only drop on disp
          if (sourceId == 'dispensary-usage' && targetId.indexOf('disp-board-container') > -1) return true
          return false
        },
        // 拖拽效果为复制
        copy: (el, source) => {
          const sourceId = source.getAttribute('id')
          if (sourceId.indexOf('dispensary-bag') > -1 || sourceId.indexOf('dispensary-usage') > -1) return true
          return false
        },
        copySortSource: false,
        revertOnSpill: true
      });
      this.subs.add(this.dragService.drop('dispensary-bag')
        .subscribe(({name, el, target, source, sibling}) => {
          // console.log(el);
          //from right to detection
          if (target.id == 'dispensary-detection') {
            this.onAddClicked(el.id.split('-')[3], el.id.split('-')[4]);
          } else if (target.id.indexOf('disp-board-container') > -1) {
            // if 'Usage' item
            // console.log(target.id)
            let targetIdx = target.id.split('-');
            let sourceIdx = el.id.split('-');
            if (sourceIdx.length > 4 && sourceIdx[3] == '7') {
              let idStr = el.id.split('-');
              let idx = idStr[4];
              let data = {
                'idx': parseInt(sourceIdx[4]),
                'zh': this.data.usages[sourceIdx[4]]['zh'],
                'en': this.data.usages[sourceIdx[4]]['en'],
                'default': this.data.usages[sourceIdx[4]]['default']
              };
              console.log(this.consultationData.chosenDisps);
              this.consultationData.chosenDisps[targetIdx[3]]['usage'].push(data);
            } else {
              let idStr = target.id.split('-');
              let idx = idStr[3];

              let obj = {};
              // Dispensary - Single
              if (sourceIdx[3] == '0') {
                obj = this.dispSinglesResult[sourceIdx[4]];
              }
              // Dispensary - Grouped
              else if (sourceIdx[3] == '1') {
                console.log(this.lastSearchStr);
                obj = this.dispGrpsResult[sourceIdx[4]];
              }
              // Internal
              else if (sourceIdx[3] == '2') {
                obj = this.dispInternalsResult[sourceIdx[4]];
              }
              // External
              else if (sourceIdx[3] == '3') {
                obj = this.dispExternalsResult[sourceIdx[4]];
              }
              // Pills
              else if (sourceIdx[3] == '4') {
                obj = this.dispPillsResult[sourceIdx[4]];
              }
              // Acupuncture - Single
              else if (sourceIdx[3] == '5') {
                obj = this.acuSinglesResult[sourceIdx[4]];
              }
              // Acupuncture - Grouped
              else if (sourceIdx[3] == '6') {
                obj = this.acuGrpsResult[sourceIdx[4]];
              } else {
                // return if not recognize
                return;
              }
              this.addDispenseItem(idx, sourceIdx[3], obj);
            }
          }
          el.parentNode.removeChild(el);
        })
      );
      /* over drop-able container
      over: (groupName?: string) => Observable<{
         name: string;
         el: Element;
         container: Element;
         source: Element;
      */
      this.subs.add(this.dragService.over().subscribe(({name, el, container, source}) => {
          // console.log(container);
          if (container.id == 'dispensary-detection') {
            $('.disp-list-detection-container').each(function (i, obj) {
              $(obj).css('opacity', '0.2');
            });
          } else {
            let idStr = container.id.split('-');
            $('#disp-board-container-' + idStr[idStr.length - 1]).css('opacity', '0.5');
          }
        })
      );

      // out from drop-able container
      this.subs.add(this.dragService.out().subscribe(({name, el, container, source}) => {
          if (container.id == 'dispensary-detection') {
            $('.disp-list-detection-container').each(function (i, obj) {
              $(obj).css('opacity', '1.0');
            });
          } else {
            let idStr = container.id.split('-');
            $('#disp-board-container-' + idStr[idStr.length - 1]).css('opacity', '1.0');
          }
        })
      );
    }
  }

  /** ----- UI Callbacks ----- **/
  onBackClicked() {

    this.navCtrl.pop();

  }

  onNavBtnClicked(inIdx) {

    this.data.activeTab = inIdx;

    // push to History and remove this page
    this.navCtrl.push(HistoryPage, {clearData: false}, {animate: false});
    this.navCtrl.remove(this.navCtrl.getViews().length - 1, 1);

  }

  onSearchSwitchClicked() {

    this.isSearchActive = !this.isSearchActive;
    if (!this.isSearchActive) {
      this.lastSearchStr = '';
      this.onSearchClicked();
    }

  }

  onAllClearClicked() {
    // prompt for confirmation
    let allClearConfirm = this.alertCtrl.create({
      title: '刪除',
      subTitle: '確認要刪除全部藥單嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {

            // clear all selection
            this.consultationData.clearAllDispenseSelection();
          }
        }
      ],
      enableBackdropDismiss: false
    });
    allClearConfirm.present();

  }

  onSymptomClicked() {
    this.sympActive = !this.sympActive;
    $('.disp-board-container').css('padding-bottom', "100px !important");
  }

  onBoardItemClicked(inIdx) {
    this.consultationData.dispBoardActive[inIdx] = !this.consultationData.dispBoardActive[inIdx];
  }

  onBoardUsageClicked(inIdx) {
    // this.consultationData.dispBoardDetailsActive[ inIdx ] = !this.consultationData.dispBoardDetailsActive[ inIdx ];
  }

  onBoardItemObjClicked(inItemIdx, inItemObjIdx) {
    let flag = this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['active'];
    this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['active'] = !flag;
  }

  onBoardItemObjPressed(inEvent, inItemIdx, inItemObjIdx) {
    console.log(this.consultationData.chosenDisps[inItemIdx].data[inItemObjIdx].type);
    if (this.consultationData.chosenDisps[inItemIdx].data[inItemObjIdx].type != 'disp-single'
      && this.consultationData.chosenDisps[inItemIdx].data[inItemObjIdx].type != 'disp-grouped'
    ) return;
    let popover = this.popoverCtrl.create(PopoverHidePage, {
      'itemIdx': inItemIdx,
      'itemObjIdx': inItemObjIdx,
      'callback': this.hideHandler
    }, {cssClass: 'hide-popover'});
    popover.present({
      ev: inEvent
    });

  }

  hideHandler = (inItemIdx, inItemObjIdx) => {
    return new Promise(resolve => {
      let flag = this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['hidden'];
      this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['hidden'] = !flag;
    });
  };

  async onSingleBoardItemObjClicked(inEvent, inItemIdx, inItemObjIdx) {
    // if (this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-grouped') return;

    if (this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-grouped') {
      let initVal = this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['default'] == 1 ? "1.0" : this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['default'];
      console.log("initVal: " + initVal);
      let popover = this.popoverCtrl.create(PopoverQuantityPage,
        {
          'init': initVal,
          'itemIdx': inItemIdx,
          'itemObjIdx': inItemObjIdx,
          'callback': this.quantityCallback
        }, {cssClass: 'quantity-popover'});
      popover.present({
        ev: inEvent
      });
    } else if (
      this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-single' ||
      this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-pills') {
      let initVal = this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default'] == 1 ? "1.0" : this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default'];
      console.log("initVal: " + initVal);
      let popover = this.popoverCtrl.create(PopoverQuantityPage,
        {
          'init': initVal,
          'itemIdx': inItemIdx,
          'itemObjIdx': inItemObjIdx,
          'callback': this.quantityCallback
        }, {cssClass: 'quantity-popover'});
      popover.present({
        ev: inEvent
      });
    } else if (
      // this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-grouped' ||
      // this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-pills' ||
      this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-internal' ||
      this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-external') {
      // let popover = this.popoverCtrl.create(PopoverDaysPage, { 'start': 1, 'end': 99, 'init': this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['default'], 'itemIdx': inItemIdx, 'itemObjIdx': inItemObjIdx, 'callback': this.quantityCallback }, { cssClass: 'quantity-days' });
      // popover.present({
      //    ev: inEvent
      // });

      await this.showSinglePicker(inEvent, inItemIdx, inItemObjIdx, {start: "1", end: "99"});
    }


  }

  quantityCallback = (inItemIdx, inItemObjIdx, inVal) => {
    return new Promise(resolve => {
      // console.log('before: ' + this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default']);
      if (this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] != "disp-grouped") {
        this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default'] = inVal;
      } else {
        this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['default'] = inVal;
      }
      // console.log('after: ' + this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default']);
    });
  };

  async onUsageBoardItemObjClicked(inEvent, inItemIdx, inItemObjIdx, inRegIdx) {

    if (inRegIdx == 0 || inRegIdx == 1 || inRegIdx == 3 || inRegIdx == 5 || inRegIdx == 6 || inRegIdx == 8) {
      let start = (inRegIdx == 0 || inRegIdx == 1 || inRegIdx == 3 || inRegIdx == 5 || inRegIdx == 6) ? 1 : (inRegIdx == 8) ? 3 : 0;
      let end = (inRegIdx == 0 || inRegIdx == 3) ? 99 : (inRegIdx == 1) ? 9 : (inRegIdx == 5) ? 30 : (inRegIdx == 6) ? 999 : (inRegIdx == 8) ? 12 : 0;
      let initVal = this.consultationData.chosenDisps[inItemIdx]['usage'][inItemObjIdx]['default'];
      // let popover = this.popoverCtrl.create(PopoverDaysPage, { 'start': start, 'end': end, 'init': initVal, 'itemIdx': inItemIdx, 'itemObjIdx': inItemObjIdx, 'callback': this.daysCallback }, { cssClass: 'quantity-days' });
      // popover.present({
      //    ev: inEvent
      // });

      await this.showSinglePicker(inEvent, inItemIdx, inItemObjIdx, {start: start, end: end}, "usage");
    } else if (inRegIdx == 18 || inRegIdx == 24) {
      // show conflicts dropdown
      let popover = this.popoverCtrl.create(PopoverSymptomPage, {
        'idx': inItemIdx,
        'itemIdx': inItemObjIdx,
        'value': this.consultationData.chosenDisps[inItemIdx]['usage'][inItemObjIdx]['default'],
        'callback': this.customCallback
      }, {cssClass: 'symptom-popover'});
      popover.present({
        ev: inEvent
      });
    }
  }

  daysCallback = (inItemIdx, inItemObjIdx, inVal) => {
    return new Promise(resolve => {
      console.log('days callback: ' + inVal);
      this.consultationData.chosenDisps[inItemIdx]['usage'][inItemObjIdx]['default'] = inVal;
    });
  };

  customCallback = (inIdx, inItemIdx, inStr) => {
    return new Promise(resolve => {
      this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['default'] = inStr;
    });
  };

  onBoardItemObjDeleteClicked(inItemIdx, inItemObjIdx) {
    let deleteConfirm = this.alertCtrl.create({
      title: '刪除',
      subTitle: '確認要刪除藥方項目嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {
            this.consultationData.clearDispenseObjSelection(inItemIdx, inItemObjIdx);
          }
        }
      ],
      enableBackdropDismiss: false
    });
    deleteConfirm.present();
  }

  onBoardItemDeleteClicked(inIdx) {
    let deleteConfirm = this.alertCtrl.create({
      title: '刪除',
      subTitle: '確認要刪除整張藥方嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {
            this.consultationData.clearDispenseSelection(inIdx);
          }
        }
      ],
      enableBackdropDismiss: false
    });
    deleteConfirm.present();
  }

  onBoardUsageItemDeletedClicked(inItemIdx, inItemObjIdx) {
    let deleteConfirm = this.alertCtrl.create({
      title: '刪除',
      subTitle: '確認要刪除服用方法嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {
            this.consultationData.chosenDisps[inItemIdx]['usage'].splice(inItemObjIdx, 1);
          }
        }
      ],
      enableBackdropDismiss: false
    });
    deleteConfirm.present();
  }

  onOptionClicked(inIdx) {

    // if NOT clicked on 'Usage'
    if (inIdx > 0) {

      let loading = this.modalCtrl.create(LoadingPage, {}, {enableBackdropDismiss: false});
      loading.present();
      this.activeTab = inIdx;
      this.lastSearchStr = '';
      $('.disp-item-scroll').each(function (i, obj) {

        $(obj).css('height', this.scrollHeight + 'px');
      });

      this.onSearchClicked().then(res => {

        loading.dismiss();
      });

    } else {
      this.lastSearchStr = '';
      this.activeTab = inIdx;
    }

  }

  onDispGrpItemClicked(inIdx) {

    this.dispGrpsActive[inIdx] = !this.dispGrpsActive[inIdx];

  }

  onDispPillsItemClicked(inIdx) {

    this.dispPillsActive[inIdx] = !this.dispPillsActive[inIdx];

  }

  onAcuGrpItemClicked(inIdx) {

    this.acuGrpsActive[inIdx] = !this.acuGrpsActive[inIdx];

  }

  onAddClicked(inGrpIdx, inIdx) {
    let obj = {};
    this.sympActive = false;
    // Dispensary-Single
    if (inGrpIdx == 0) {
      obj = this.dispSinglesResult[inIdx];
      // this.consultationData.med = true;
    }
    // Dispensary-Grouped
    else if (inGrpIdx == 1) {
      obj = this.dispGrpsResult[inIdx];
      // this.consultationData.med = true;
    }
    // Internal
    else if (inGrpIdx == 2) {
      obj = this.dispInternalsResult[inIdx];
    }
    // External
    else if (inGrpIdx == 3) {
      obj = this.dispExternalsResult[inIdx];
    }
    // Pills
    else if (inGrpIdx == 4) {
      obj = this.dispPillsResult[inIdx];
    }
    // Acupuncture-Single
    else if (inGrpIdx == 5) {
      obj = this.acuSinglesResult[inIdx];
      // this.consultationData.acu = true;
    }
    // Acupuncture-Grouped
    else if (inGrpIdx == 6) {
      obj = this.acuGrpsResult[inIdx];
      // this.consultationData.acu = true;
    }
    console.log("obj: ");
    console.log(obj);
    if (inGrpIdx == 1 || inGrpIdx == 6) {
      if (obj != null) this.addDispense(inGrpIdx, obj);
    } else {
      if (obj != null) this.addDispense(inGrpIdx, Object.assign({}, obj));
    }
    this.lastSearchStr = ""
    this.onSearchClicked()
    this.isSearchActive = false;
  }

  onNextClicked() {

    this.navCtrl.push(VerificationPage);
    // this.constants.tempData['' + this.data.selectedPatient['id']] = this.consultationData.chosenDisps;
    // console.log(JSON.stringify(this.constants.tempData));
    // this.consultationData.chosenDisps = [];
    // this.data.consRemark = '';
    // this.data.chosenSymptoms = [];
    // this.data.chosenSymptomsRemarks = [];
    // this.data.dxIdx = -1;
    // this.data.dxCustom = '';
    // this.data.currentStep = 0;


    // this.navCtrl.remove(2, 2).then(res => {

    //    this.navCtrl.pop();
    // });


  }

  onSearchClicked = () => {
    return new Promise<void>(resolve => {

      // Dispensary - Single
      if (this.activeTab == 2) {
        this.searchDispSingle(this.lastSearchStr).then(res => {

          resolve();
        });
      }
      // Dispensary - Grouped
      else if (this.activeTab == 1) {
        this.searchDispGrp(this.lastSearchStr).then(res => {

          resolve();
        });
      }
      // Dispensary - Internal
      else if (this.activeTab == 4) {
        this.searchDispInternal(this.lastSearchStr).then(res => {

          resolve();
        });
      }
      // Dispensary - External
      else if (this.activeTab == 5) {
        this.searchDispExternal(this.lastSearchStr).then(res => {

          resolve();
        });
      }
      // Dispensary - Pills
      else if (this.activeTab == 3) {
        this.searchDispPills(this.lastSearchStr).then(res => {

          resolve();
        });
      }
      // Acupuncture - Single
      else if (this.activeTab == 7) {
        this.searchAcuSingle(this.lastSearchStr).then(res => {

          resolve();
        });
      }
      // Acupunctunre - Grouped
      else if (this.activeTab == 6) {
        this.searchAcuGrp(this.lastSearchStr).then(res => {

          resolve();
        });
      }
    });
  };

  searchDispSingle = (inStr) => {
    this.dispSinglesResult = [];
    return new Promise<void>(resolve => {

      // clear search result
      this.dispSinglesResult = [];

      // use default result OR search result
      this.dispSinglesResult = (this.lastSearchStr == null || this.lastSearchStr == '') ? this.data.dispSingles : $.grep(this.data.dispSingles, function (element, sindex) {

        return (element['name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1 ||
          element['name_en'].toLowerCase().indexOf(inStr.toLowerCase()) > -1 ||
          element['category_name'].toLowerCase().indexOf(inStr.toLowerCase()) > -1);
      });
      resolve();
    });
  };

  searchDispGrp = (inStr) => {
    return new Promise<void>(resolve => {

      // clear search result
      this.dispGrpsResult = [];
      this.dispGrpsContentResult = [];
      this.dispGrpsActive = [];

      // use default result OR search result
      let dispGrpData = (this.lastSearchStr == null || this.lastSearchStr == '') ? this.data.dispGrps : $.grep(this.data.dispGrps, function (element, sindex) {

        return (element['name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1 ||
          element['name_en'].toLowerCase().indexOf(inStr.toLowerCase()) > -1);
      });
      // pack result
      for (let i = 0; i < dispGrpData.length; i++) {
        let tempIdx = this.dispGrpsResult.indexOf(dispGrpData[i]['grp_id']);
        if (tempIdx > -1) {
          this.dispGrpsContentResult[tempIdx].push({
            'id': dispGrpData[i]['item_id'],
            'ratio': dispGrpData[i]['ratio'],
            'name_zh': dispGrpData[i]['name_zh']
          });
        } else {
          this.dispGrpsResult.push(dispGrpData[i]['grp_id']);
          this.dispGrpsContentResult.push([{
            'id': dispGrpData[i]['item_id'],
            'ratio': dispGrpData[i]['ratio'],
            'name_zh': dispGrpData[i]['name_zh']
          }]);
        }
      }

      // reset collapse / expand status
      for (let i = 0; i < this.dispGrpsResult.length; i++) {
        this.dispGrpsActive.push(false);
      }
      resolve();
    });

  };

  searchDispInternal = (inStr) => {

    return new Promise<void>(resolve => {

      // clear search result
      this.dispInternalsResult = [];

      // use default result OR search result
      this.dispInternalsResult = (this.lastSearchStr == null || this.lastSearchStr == '') ? this.data.dispInternals : $.grep(this.data.dispInternals, function (element, sindex) {

        return (element['name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1);
      });
      resolve();
    });
  };

  searchDispExternal = (inStr) => {

    return new Promise<void>(resolve => {

      // clear search result
      this.dispExternalsResult = [];

      // use default result OR search result
      this.dispExternalsResult = (this.lastSearchStr == null || this.lastSearchStr == '') ? this.data.dispExternals : $.grep(this.data.dispExternals, function (element, sindex) {

        return (element['name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1);
      });
      resolve();
    });
  };

  searchDispPills = (inStr) => {

    return new Promise<void>(resolve => {

      // clear search result
      this.dispPillsResult = [];
      this.dispPillsContentResult = [];
      this.dispPillsActive = [];

      // use default result OR search result
      let dispPillsData = (this.lastSearchStr == null || this.lastSearchStr == '') ? this.data.dispPills : $.grep(this.data.dispPills, function (element, sindex) {

        return (element['name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1 ||
          element['name_en'].toLowerCase().indexOf(inStr.toLowerCase()) > -1);
      });

      // pack result
      for (let i = 0; i < dispPillsData.length; i++) {
        let tempIdx = this.dispPillsResult.indexOf(dispPillsData[i]['grp_id']);
        tempIdx = -1;
        for (let j = 0; j < this.dispPillsResult.length; j++) {

          if (this.dispPillsResult[j].id == dispPillsData[i]['grp_id']) {
            tempIdx = j;
          }
        }
        if (tempIdx > -1) {
          this.dispPillsContentResult[tempIdx].push(dispPillsData[i]['item_name_zh']);
        } else {
          this.dispPillsResult.push({'id': dispPillsData[i]['grp_id'], 'default': dispPillsData[i]['default']});
          this.dispPillsContentResult.push([dispPillsData[i]['item_name_zh']]);
        }
      }
      // reset collapse / expand status
      for (let i = 0; i < this.dispPillsResult.length; i++) {
        this.dispPillsActive.push(false);
      }
      resolve();
    });
  };

  searchAcuSingle = (inStr) => {

    return new Promise<void>(resolve => {

      // clear search result
      this.acuSinglesResult = [];

      // use default result OR search result
      this.acuSinglesResult = (this.lastSearchStr == null || this.lastSearchStr == '') ? this.data.acuSingles : $.grep(this.data.acuSingles, function (element, sindex) {

        return (element['name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1 ||
          element['details'].toLowerCase().indexOf(inStr.toLowerCase()) > -1);
      });
      resolve();
    });
  };

  // 寻找复针选项列表
  searchAcuGrp = (inStr) => {
    return new Promise<void>(resolve => {
      // clear search result
      this.acuGrpsResult = []; // 清空复针 grp_id 列表
      this.acuGrpsContentResult = []; // 清空复针卡片列表
      this.acuGrpsActive = []; // 清空复针卡片是否展开 boolean 列表
      // use default result OR search result
      let acuGrpsData = (this.lastSearchStr == null || this.lastSearchStr == '') ?
        this.data.acuGrps
        : $.grep(this.data.acuGrps, function (element, sindex) {

          return (element['name_zh'] != null ? element['name_zh'].toLowerCase().indexOf(inStr.toLowerCase()) > -1 : false ||
          element['name_en'] != null ? element['name_en'].toLowerCase().indexOf(inStr.toLowerCase()) > -1 : false);
        });

      // pack result
      for (let i = 0; i < acuGrpsData.length; i++) {
        let tempIdx = this.acuGrpsResult.indexOf(acuGrpsData[i]['grp_id']);
        if (tempIdx > -1) {
          this.acuGrpsContentResult[tempIdx].push({'item_name': acuGrpsData[i]['item_name']});
        } else {
          this.acuGrpsResult.push(acuGrpsData[i]['grp_id']);
          this.acuGrpsContentResult.push([{'item_name': acuGrpsData[i]['item_name']}]);
        }
      }

      // reset collapse / expand status
      for (let i = 0; i < this.acuGrpsResult.length; i++) {
        this.acuGrpsActive.push(false);
      }
      resolve();
    });
  };

  showUsageString(inIdx) {

    let str = this.data.usages[inIdx]['zh'];
    str = str.replace('/*', '<span>');
    str = str.replace('*/', '</span>');
    $('#disp-item-container-str-7-' + inIdx).html(str);

  }

  showUsageItemPrefix(inIdx, inItemIdx) {
    let zhStr = this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['zh'];
    let zhStart = zhStr.indexOf('(');
    let zhEnd = zhStr.indexOf(')');
    if (zhStart > -1 && zhEnd > -1) zhStr = zhStr.substring(0, zhStart);
    return (zhStr);
  }

  showUsageItemDefault(inIdx, inItemIdx) {
    let zhStr = this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['zh'];
    let zhStart = zhStr.indexOf('(');
    let zhEnd = zhStr.indexOf(')');
    return (zhStart > -1 && zhEnd > -1) ? this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['default'] : '';
  }

  showUsageItemSuffix(inIdx, inItemIdx) {
    let zhStr = this.consultationData.chosenDisps[inIdx]['usage'][inItemIdx]['zh'];
    let zhStart = zhStr.indexOf('(');
    let zhEnd = zhStr.indexOf(')');
    if (zhStart > -1 && zhEnd > -1 && zhEnd + 2 < zhStr.length) {
      return zhStr.substring(zhEnd + 2, zhStr.length);
    } else {
      return '';
    }
  }

  onQueueBtnClicked(inEvent) {
    let dxPopover = this.popoverCtrl.create(PopoverQueuePage, {}, {cssClass: 'queue-popover'});
    dxPopover.present({
      ev: inEvent
    });
  }

  // 新增药方
  addDispense(inGrpIdx, inObj) {
    // add dispensary item to list
    // this.dispBoardActive.push( false );
    // this.dispBoardDetailsActive.push( false );
    let obj = {};
    obj['data'] = [];
    obj['usage'] = [];
    obj['dispBoardDetailsActive'] = true;
    // create empty disp
    this.consultationData.chosenDisps.push(obj);
    const dispIndex = this.consultationData.chosenDisps.length - 1;
    // add item to disp
    this.addDispenseItem(dispIndex, inGrpIdx, inObj);
    console.log(this.consultationData.chosenDisps);
  }

  // 药方添加 item
  addDispenseItem(inTargetIdx, inGrpIdx, inObj) {
    console.log('addDispenseItem', inObj);
    inGrpIdx = Number(inGrpIdx);
    if (inGrpIdx < 0 || inGrpIdx > 6) return;
    if (!this.checkIfCanCombine(this.consultationData.chosenDisps[inTargetIdx]['data'], inGrpIdx)) return;

    let params = {};
    params["active"] = false;
    // need to be a different object to edit the item weight
    params["details"] = deepClone(inObj)

    switch (inGrpIdx) {
      case 0: // Dispensary-Single
        params['type'] = 'disp-single';
        params['hidden'] = false;
        break;
      case 1: // Dispensary-Grouped
        params['type'] = 'disp-grouped';
        params["default"] = 0.0;
        params['hidden'] = false;
        for (let i = 0; i < this.dispGrpsResult.length; i++) {
          if (this.dispGrpsResult[i] == inObj) {
            params["data"] = this.dispGrpsContentResult[i];
          }
        }
        break;
      case 2: // Internal
        params['type'] = 'disp-internal';
        break;
      case 3: // External
        params['type'] = 'disp-external';
        break;
      case 4: // Pills
        params['type'] = 'disp-pills';
        for (let i = 0; i < this.dispPillsResult.length; i++) {
          if (this.dispPillsResult[i].id == inObj.id) {
            params["data"] = this.dispPillsContentResult[i];
          }
        }
        break;
      case 5: // Acupuncture-Single
        params['type'] = 'acu-single';
        break;
      case 6: // Acupuncture-Grouped
        params['type'] = 'acu-grouped';
        for (let i = 0; i < this.acuGrpsResult.length; i++) {
          if (this.acuGrpsResult[i] == inObj) {
            params["data"] = this.acuGrpsContentResult[i];
          }
        }
        break;
    }

    this.consultationData.chosenDisps[inTargetIdx]['data'].push(params);
    this.consultationData.chosenDisps[inTargetIdx]['data'].sort(function (a, b) {
      var typeA = a['type'];
      var typeB = b['type'];
      if (typeA == 'disp-grouped' || typeA == 'disp-internal' || typeA == 'disp-external')
        return -1;
      else
        return 1;
    });
    console.log(this.consultationData.chosenDisps);
    this.lastSearchStr = "";
    this.onSearchClicked();
    this.isSearchActive = false;
    setTimeout(() => {
      this.adjustFontSize();
    }, 100);
  }
  adjustFontSize () {
    const title = document.querySelectorAll('.disp-item-obj-title');
    title.forEach((item) => {
      if (!item.querySelector('span') || !item.querySelector('div.disp-input') || this.modifiedElements.has(item)) return;
      this.modifiedElements.add(item);
      const width = item.clientWidth;
      const textWidth = item.querySelector('span').scrollWidth;
      const inputWidth = item.querySelector('div.disp-input').scrollWidth;
      console.log(textWidth, width, inputWidth);
      if (textWidth > (width - inputWidth - 20)) {
        const fontSize = ((width - inputWidth - 20) / textWidth) * 20;
        this.renderer.setStyle(item.querySelector('span'), 'font-size', fontSize + 'px');
      }
    }) 
  }

  getDispGrpById(inId) {
    return this.data.getDispGrpById(inId);
  }

  getDispPillById(inId) {
    return this.data.getDispPillById(inId);
  }

  getAcuGrpById(inId) {
    return this.data.getAcuGrpById(inId);
  }

  getDispSingleById(inId) {
    return this.data.getDispSingleById(inId);
  }

  checkIfCanCombine(data, inGrpIdx) {
    let canAcceptedIdx: number[] = [];
    if (inGrpIdx == 0 || inGrpIdx == 1) {
      canAcceptedIdx.push(0);
      canAcceptedIdx.push(1);
    } else if (inGrpIdx == 2 || inGrpIdx == 3 || inGrpIdx == 4) {
      canAcceptedIdx.push(2);
      canAcceptedIdx.push(3);
      canAcceptedIdx.push(4);
    } else if (inGrpIdx == 5 || inGrpIdx == 6) {
      canAcceptedIdx.push(5);
      canAcceptedIdx.push(6);
    }

    for (let i = 0; i < data.length; i++) {
      let grpIdx = this.getGrpIndexByName(data[i].type);
      if (canAcceptedIdx.indexOf(grpIdx) == -1) {
        return false;
      }
    }
    return true;
  }

  getGrpIndexByName(type: string) {
    if (type == "disp-single") {
      return 0;
    } else if (type == "disp-grouped") {
      return 1;
    } else if (type == "disp-internal") {
      return 2;
    } else if (type == "disp-external") {
      return 3;
    } else if (type == "disp-pills") {
      return 4;
    } else if (type == "acu-single") {
      return 5;
    } else if (type == "acu-grouped") {
      return 6;
    }
    return -1;
  }

  onAcuButtoClick(mode) {
    let param = {
      'token': this.data.token,
      'tkt_id': this.data.selectedTicket['tkt_id'],
      'is_start_acu': mode
    };
    // prompt for confirmation
    let onStastAcuConfirm = this.alertCtrl.create({
      title: mode == 1 ? '開始針灸' : '完成針灸',
      subTitle: mode == 1 ? '是否確認開始針灸?' : '是否確認完成針灸?',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {
            let loading = this.modalCtrl.create(LoadingPage, {}, {enableBackdropDismiss: false});
            loading.present();
            // clear all selection
            this.cloudData.acuButtonClicked(param)
              .then(res => {
                if (res['status'])
                  this.data.selectedTicket = res['result']['ticket'];
                loading.dismiss();
              })
              .catch(err => {
                loading.dismiss();
              });
          }
        }
      ],
      enableBackdropDismiss: false
    });
    onStastAcuConfirm.present();
  }

  async showPicker(inEvent, inItemIdx, inItemObjIdx) {
    console.log(inItemIdx);
    console.log(inItemObjIdx);

    let options = {
      buttons: [
        {
          text: "取消",
          role: 'cancel'
        },
        {
          text: '確定',
          handler: (value: any) => {

            console.log(value);
            let newValue = parseFloat(value.col0.value + value.col1.text);
            console.log(newValue);

            if (this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-grouped') {
              this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['default'] = newValue;
            } else {
              this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default'] = newValue;
            }
          }
        }
      ],
      cssClass: 'disp-picker',
      columns: this.getColumns(inItemIdx, inItemObjIdx),

    };

    let picker = await this.pickerController.create(options);
    picker.present();
  }

  getColumns(inItemIdx, inItemObjIdx) {
    let defaultValue;
    if (this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['type'] == 'disp-grouped') {
      defaultValue = (this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['default']).toString();
    } else {
      defaultValue = (this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default']).toString();
    }
    defaultValue = defaultValue.split(".");

    if (defaultValue.length == 1) {
      defaultValue = [defaultValue[0], '0'];
    }

    let columns = [];
    for (let i = 0; i < this.numColumns; i++) {
      let obj = {
        name: `col${i}`,
        options: this.getColumnOptions(i),
        selectedIndex: undefined
      };

      if (i === 0) {
        obj.selectedIndex = parseInt(defaultValue[0]);
      } else {

        console.log("~~~~");
        console.log(defaultValue[1]);

        let v = "." + (defaultValue[1]).toString();
        console.log(v);

        obj.selectedIndex = 0;

        for (let j = 0; j < this.secondUnit[1].length; j++) {
          if (this.secondUnit[1][j] === v) {
            obj.selectedIndex = j;
          }
          if (this.secondUnit[1][j] === v + "0") {
            obj.selectedIndex = j;
          }
        }

        //obj.selectedIndex = parseInt(defaultValue[1]);
      }

      columns.push(obj);
    }
    return columns;
  }

  getColumnOptions(columIndex: number) {

    let options = [];

    if (columIndex == 0) {
      for (let i = 0; i < 31; i++) {
        let obj = {
          text: i,
          value: i
        };
        options.push(obj);
      }
    } else {
      for (let i = 0; i < this.secondUnit[columIndex].length; i++) {
        let obj = {
          text: this.secondUnit[columIndex][i],
          value: i
        };
        options.push(obj);
      }
    }

    return options;
  }

  async showSinglePicker(inEvent, inItemIdx, inItemObjIdx, range, type = "") {
    console.log("showSinglePicker");

    let defaultValue;

    if (type === "usage") {
      defaultValue = this.consultationData.chosenDisps[inItemIdx]['usage'][inItemObjIdx]['default'];
    } else {
      defaultValue = this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default'];
    }
    defaultValue = parseInt(defaultValue);

    let columnsOptions = [];
    let selectedIndex = undefined;
    let start = range.start;
    let end = range.end;
    let index = 0;

    for (let i = start; i <= end; i++) {
      let obj = {
        text: i,
        value: i,
        selectedIndex: undefined
      };
      if (i === defaultValue) {
        selectedIndex = index;
      }
      columnsOptions.push(obj);

      index++;
    }

    let columns = {
      name: "single",
      options: columnsOptions,
      selectedIndex: selectedIndex
    };


    let options = {
      buttons: [
        {
          text: "取消",
          role: 'cancel'
        },
        {
          text: '確定',
          handler: (value: any) => {
            console.log(value);
            if (type === "usage") {
              this.consultationData.chosenDisps[inItemIdx]['usage'][inItemObjIdx]['default'] = value.single.value;
            } else {
              this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default'] = value.single.value;
            }
          }
        }
      ],
      cssClass: 'disp-picker',
      columns: [columns],
    };

    let picker = await this.pickerController.create(options);
    picker.present();
  }

  submitSearch($event) {
    this.onSearchClicked();
    this.isSearchActive = false;
  }
  onSearchInput ($event) {
    this.lastSearchStr = $event.target.value;
    this.onSearchClicked();
    // if(this.lastSearchStr == "") {
    //   this.isSearchActive = false;
    // }
  }
  formatInput (event: any, num: number = 2, max: number = 99999, min: number = 0, inItemIdx, inItemObjIdx, type) {
    let value = event.target.value;
    if (type === "usage") {
      const inRegIdx = this.consultationData.chosenDisps[inItemIdx]['usage'][inItemObjIdx]['idx'];
      min = (inRegIdx == 0 || inRegIdx == 1 || inRegIdx == 3 || inRegIdx == 5 || inRegIdx == 6) ? 1 : (inRegIdx == 8) ? 3 : 0;
      max = (inRegIdx == 0 || inRegIdx == 3) ? 99 : (inRegIdx == 1) ? 9 : (inRegIdx == 5) ? 30 : (inRegIdx == 6 || inRegIdx == 25 || inRegIdx == 26 || inRegIdx == 27) ? 999 : (inRegIdx == 8) ? 12 : 0;
    }
    if (event !== null) {
      const parsedValue = parseFloat(event.target.value);
      const sanitizedValue = isNaN(parsedValue) ? min : Math.min(Math.max(parsedValue, min), max);
      value = sanitizedValue.toFixed(num).replace(/\.0+$/, '');
    }
    if (type === "usage") {
      this.consultationData.chosenDisps[inItemIdx]['usage'][inItemObjIdx]['default'] = value;
    } else if(type === "details") {
      this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['details']['default'] = value;
    } else {
      this.consultationData.chosenDisps[inItemIdx]['data'][inItemObjIdx]['default'] = value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dispensary/dispensary.ts